import { createReducer, on } from '@ngrx/store';

import { clearAuth, setAuth } from './auth.actions';

export const initialState: AuthModel = null;

export const authReducer = createReducer(
  initialState,

  on(clearAuth, () => initialState),

  on(setAuth, (state, { auth }) => auth),

);
